// Compose
import {
  compose,
  withHandlers,
  withPropsOnChange,
  withProps,
  withState
} from 'recompose'
import { connect } from 'react-redux'
import React from 'react'
import { NoRecords } from '../../../theme/Table'

// Component pieces
import handlers from './handlers'
import props from './props'
import renderer from './renderer'
import { isAppLoading } from '../../selectors'
import { stateList } from '../../../common/helpers'

const DataTableComponent = compose(
  withState('search', 'setSearch', ''),
  withState('sortBy', 'setSortBy', (props) => {
    if (props.defaultSort && props.defaultSort.sortBy) {
      return props.defaultSort.sortBy
    }
    return null
  }),
  withState('sortDirection', 'setSortDirection', (props) => {
    if (props.defaultSort && props.defaultSort.direction) {
      return props.defaultSort.direction
    }
    return 'ASC'
  }),
  withState('sortIndex', 'setSortIndex', 0),
  withState('sortText', 'setSortText', ''),
  withState('currentPage', 'setCurrentPage', 0),
  withState('perPage', 'setPerPage', (props) => {
    return props.perPage ? props.perPage : 20
  }),
  withProps(props),
  withPropsOnChange(['data'], (props) => {
    props.onSort(props)
    props.setCurrentPage(0)
  }),
  withHandlers(handlers)
)(renderer)

DataTableComponent.propTypes = {}

DataTableComponent.defaultProps = {
  columns: [],
  emptyMessage: (
    <NoRecords>
      <p>No Records</p>
    </NoRecords>
  ),
  exports: ['csv'],
  headerHeight: 40,
  onExport: null,
  onFilter: null,
  onSearch: null,
  onSort: null,
  rowHeight: 70,
  recordType: 'records',
  searchDelay: 300,
  showCount: true,
  showControls: true,
  showDateFilter: true,
  showExport: true,
  showLocaleFilter: true,
  showSearch: true,
  stateList: []
}

const mapStateToProps = (state, props) => ({
  isLoading: isAppLoading(state),
  stateList: props.stateList || stateList
})

export default connect(
  mapStateToProps
)(DataTableComponent)
